import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { generateCorrelationId } from '../util';
class APIClient {
  static timeout = 15000;
  apiClient: AxiosInstance;
  apiClientCyberSource: AxiosInstance;

  constructor() {
    this.apiClient = axios.create();
    this.apiClientCyberSource = axios.create();
    this.get = this.get.bind(this);
    this.post = this.post.bind(this);
    this.put = this.put.bind(this);
    this.delete = this.delete.bind(this);
    this.postAll = this.postAll.bind(this);
    this.apiClient.interceptors.request.use(this.setCorrIdHeader);
    this.apiClient.interceptors.request.use(this.setAuthHeader);
    this.apiClientCyberSource.interceptors.request.use(this.setCyberAuthHeader);
    this.apiClient.interceptors.response.use((response) => response, this.checkResponseForTokenExpiration);
  }
  async postAll<T1, T2>(req: T1[], url): Promise<T2[]> {
    const x = req.map((y) => {
      return this.apiClient.post<T1, T2>(url, y);
    });
    const z = await axios.all(x);

    return z;
  }
  setAuthHeader = (req: AxiosRequestConfig): AxiosRequestConfig => {
    req.headers['Authorization'] = `Bearer ${sessionStorage.getItem('API_TOKEN')}`;
    return req;
  };
  setCyberAuthHeader = (req: AxiosRequestConfig): AxiosRequestConfig => {
    req.headers['Authorization'] = `Bearer ${sessionStorage.getItem('API_TOKEN')}`;
    req.headers['x-correlation-id'] = generateCorrelationId();
    return req;
  };
  setCorrIdHeader = (req: AxiosRequestConfig): AxiosRequestConfig => {
    req.headers = req.headers || {};
    req.headers['X-correlation-id'] = generateCorrelationId();
    return req;
  };
  checkResponseForTokenExpiration = (error: any) => {
    if (error.response.status === 401) {
      error.response.tokenExpired = true;
    }
    return Promise.reject(error);
  };
  async get<T>(url: string): Promise<T> {
    if (url && url.length > 0) {
      const resp: AxiosResponse<T> = await this.apiClient.get<string, AxiosResponse<T>>(url);
      const { data } = resp;
      return data;
    } else {
      throw Error('Missing Url');
    }
  }
  async post<T1, T2>(url: string, params: T1): Promise<T2> {
    if (url && url.length > 0) {
      const resp: AxiosResponse<T2> = await this.apiClient.post(url, params);
      const { data } = resp;
      return data;
    } else {
      throw Error('Missing Url');
    }
  }

  async postCyberSource<T1, T2>(url: string, params: T1): Promise<T2> {
    if (url && url.length > 0) {
      const resp: AxiosResponse<T2> = await this.apiClientCyberSource.post(url, params);
      const { data } = resp;
      return data;
    } else {
      throw Error('Missing Url');
    }
  }

  async delete(url: string) {
    try {
      return await this.apiClient.delete(url);
    } catch (error) {
      console.log(error);
    }
  }

  async put(url: string, params: object) {
    try {
      return await this.apiClient.put(url, params);
    } catch (error) {
      console.log(error);
    }
  }

  async patch(url: string, params: object) {
    try {
      return await this.apiClient.patch(url, params);
    } catch (error) {
      console.log(error);
    }
  }
}

export default new APIClient();
